import { observable, action, runInAction} from 'mobx'
import { json } from '../../../../../utils/ajax'

class contentStore {
  @observable loading
  @observable content
  @observable categoryName


  constructor () {
    this.loading = false;
    this.content = {};
    this.categoryName = '';
  }
  @action
  init = async(id) =>{
    runInAction(()=>{
      this.loading = true;
    })

    const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/cms/news/id/${id}`);
    if(res && res.status === 0){
      return;
    }
    const category = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/cms/category/id/${res.categoryId}`);
    if(category && category.status === 0){
      return;
    }
    runInAction(()=>{
      this.categoryName = category.name;
      this.content = res;
      this.loading = false;
    })
  }
}
export default new contentStore()


// WEBPACK FOOTER //
// ./src/project/dongfeng/homePage/content/Content/store.js